// Import utilities
const {
	isDefined
} = _uo.utility;

/**
 * Determines if the user can schedule an action or add delay
 *
 * @return {Boolean} True if the user can schedule an action or add delay
 */
const canManageSchedule = () => {
	return isDefined( UncannyAutomator.wp ) && UncannyAutomator.wp;
};

export default canManageSchedule;
